import _objectWithoutProperties from "/Users/milindsaiwaghrey/Repos/milind/spacestagram/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Button } from './Button.js';

function buttonsFrom(actions) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (Array.isArray(actions)) {
    return actions.map(function (action, index) {
      return buttonFrom(action, overrides, index);
    });
  } else {
    var action = actions;
    return buttonFrom(action, overrides);
  }
}

function buttonFrom(_ref, overrides, key) {
  var content = _ref.content,
      onAction = _ref.onAction,
      action = _objectWithoutProperties(_ref, ["content", "onAction"]);

  return /*#__PURE__*/React.createElement(Button, Object.assign({
    key: key,
    onClick: onAction
  }, action, overrides), content);
}

export { buttonFrom, buttonsFrom };